// model imports
import { MaterialListRequest } from './../model/materials/material_list_request.model';
//import { MaterialListResponse } from './../model/materials/material_list_response.model';
import { OrderRequest } from './../model/order/order_request.model';
import { OrderResponse } from './../model/order/order_response.model';
import { DeliveryRequest } from '../model/delivery/delivery_request.model';
import { DeliveryResponse } from '../model/delivery/delivery_response.model';
import { BomRequest } from './../model/bom/bom_request.model';
import { StockRequest } from '../model/stock/stock_request.model';
import { StockResponse } from '../model/stock/stock_response.model';
import { LotRequest } from '../model/lot/lot_request.model';
import { LotResponse } from '../model/lot/lot_response.model';
import { LotCharactsRequest } from '../model/lot/lot_characts_request.model';
import { LotCharactsResponse } from '../model/lot/lot_characts_response.model';
import { SupplyDocRequest } from '../model/supply-doc/supply_doc_request.model';
import { SupplyDocResponse } from '../model/supply-doc/supply_doc_response.model';
import { MaterialDocRequest } from '../model/materials/material_doc_request.model';
import { MaterialDocResponse } from '../model/materials/material_doc_response.model';
import { BomResponse } from '../model/bom/bom_response-model';

// this class expose the service responses and various things to any module
export class ModelsManager {
    // material
    public material_list_request: MaterialListRequest = new MaterialListRequest();
    //public material_list_response = new MaterialListResponse();
    // bom
    public bom_request: BomRequest = new BomRequest();
    public bom_response: BomResponse = new BomResponse();
    // order
    public order_request: OrderRequest = new OrderRequest();
    public order_response: OrderResponse = new OrderResponse();
    // delivery
    public delivery_request: DeliveryRequest = new DeliveryRequest();
    public delivery_response: DeliveryResponse = new DeliveryResponse();
    // stock
    public stock_request: StockRequest = new StockRequest();
    public stock_response: StockResponse = new StockResponse();
    // lot
    public lot_request: LotRequest = new LotRequest();
    public lot_response: LotResponse = new LotResponse();
    // lot characteristics
    public lot_characts_request: LotCharactsRequest = new LotCharactsRequest();
    public lot_characts_response: LotCharactsResponse = new LotCharactsResponse();
    // supply document
    public supply_doc_request: SupplyDocRequest = new SupplyDocRequest();
    public supply_doc_response: SupplyDocResponse = new SupplyDocResponse();
    // material document
    public material_doc_request: MaterialDocRequest = new MaterialDocRequest();
    public material_doc_response: MaterialDocResponse = new MaterialDocResponse();
}



// WEBPACK FOOTER //
// ./src/app/manager/models.manager.ts